import {Injectable} from '@angular/core';
import {RestApi} from 'app/auth/rest.api';
import {BehaviorSubject} from 'rxjs';
import {MenuOptionsActions} from '../reducers/options.actions';

@Injectable()
export class NavigationService {

  public mainMenuNavItems = new BehaviorSubject<Array<INavItem>>([]);
  public settingsMenuNavItems = new BehaviorSubject<Array<INavItem>>([]);
  
  constructor(private _api: RestApi,
            private _menuOptionsActions: MenuOptionsActions) {
    this.getMenus();
  }

  public getMenus() {
    this._api.get('api/menuAuthorization/menus').subscribe((response => {
      this.mainMenuNavItems.next(response.MainMenu);
      this.settingsMenuNavItems.next(response.SettingsMenu);

      const options = { }

      response.MainMenu.map(menu => {
        menu.SubItems.map(subItem => {
          if(subItem.Options) {
            options[subItem.Name] = subItem.Options;
          }
        });
      });

      this._menuOptionsActions.Add(options);
    }));
  }

  public updateMenus() {
    this._api.get('api/menuAuthorization/menus').subscribe((response => {

      const options = { }

      response.MainMenu.map(menu => {
        menu.SubItems.map(subItem => {
          if(subItem.Options) {
            options[subItem.Name] = subItem.Options;
          }
        });
      });

      this._menuOptionsActions.Add(options);
    }));
  }
}
